import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function EnvironmentalAspects() {
  const { data, siteNames } = useHSE();
  const rows = data.environmentalAspects || [];

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/environmental-aspects", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `env-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Total Aspects" value={rows.length} testid="env-total" />
      <StatCard label="Significant Impact" value={rows.filter((r) => r.significanceLevel === "significant" || (r.significanceScore || 0) >= 15).length} tone="critical" />
      <StatCard label="Medium Impact" value={rows.filter((r) => r.significanceLevel === "medium" || ((r.significanceScore || 0) >= 8 && (r.significanceScore || 0) < 15)).length} tone="warning" />
      <StatCard label="Low Impact" value={rows.filter((r) => r.significanceLevel === "low" || (r.significanceScore || 0) < 8).length} tone="safe" />
    </div>
  );

  return (
    <RegisterPage
      title="Environmental Aspects & Impact Register"
      subtitle="ISO 14001 Clause 6.1.2 — Aspect/Impact Identification, Significance Scoring & Operational Controls"
      storeKey="environmentalAspects"
      idPrefix="ENV"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "Aspect ID" },
        { key: "activityName", label: "Activity / Process" },
        { key: "aspectName", label: "Environmental Aspect" },
        { key: "impactDescription", label: "Impact Description" },
        { key: "significanceScore", label: "Significance Score", render: (r) => <span className="font-mono font-bold">{r.significanceScore || (Number(r.severity || 3) * Number(r.probability || 3))}</span> },
        { key: "significanceLevel", label: "Impact Level", render: (r) => <span className={`uppercase text-[10px] font-bold px-2 py-0.5 rounded ${r.significanceLevel === "significant" ? "bg-rose-100 text-rose-800" : r.significanceLevel === "medium" ? "bg-amber-100 text-amber-800" : "bg-emerald-100 text-emerald-800"}`}>{r.significanceLevel || "low"}</span> },
        { key: "legalObligation", label: "Legal Obligation" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Aspect ID" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "activityName", label: "Activity / Process Name" },
        { key: "aspectName", label: "Environmental Aspect" },
        { key: "impactDescription", label: "Environmental Impact Description", type: "textarea", full: true },
        { key: "legalObligation", label: "Linked Legal Obligation" },
        { key: "severity", label: "Severity (1-5)", type: "number" },
        { key: "probability", label: "Probability (1-5)", type: "number" },
        { key: "operationalControls", label: "Operational Controls & Mitigation", type: "textarea", full: true },
        { key: "status", label: "Status", type: "select", options: ["active", "inactive"] },
      ]}
    />
  );
}
